import styled, { CSSObject } from 'styled-components';
import { ILoaderProps } from './loader.component';

const InlineStyle: CSSObject = {
    position: 'relative',
    textAlign: 'center'
};

const AbsoluteStyle: CSSObject = {
    top: '50%',
    left: '50%',
    position: 'absolute',
    textAlign: 'center',
    transform: 'translate(-50%, -50%)'
};

export const Container = styled.div<ILoaderProps>`
    ${(props: ILoaderProps): CSSObject => props.inline ? InlineStyle : AbsoluteStyle}
`;
